import { useEffect } from "react";
import { AppToasterV2, CoreFieldValue, MultiStepItemProps } from "@ucl/library";
import { JointAccountOwners } from "./JointAccountOwners";
import { useJointAccountOwners } from "@/hooks/useJointAccountOwners";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface JointAccountOwnersStepProps extends MultiStepItemProps {
  financialApplicationId: string;
  onBlur?: (field: CoreFieldValue) => void;
  initiallyCollapseJointAccountOwnerForms?: boolean;
  readOnly?: boolean;
  renderCollapsedAsTable?: boolean;
}

export const JointAccountOwnersStep: React.FC<JointAccountOwnersStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <JointAccountOwnersStepInner {...props} />
    </RequireAuth>
  );
};

const JointAccountOwnersStepInner: React.FC<JointAccountOwnersStepProps> = (props) => {
  const { validateJointAccountOwners } = useJointAccountOwners(
    props.financialApplicationId
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const doNotHaveValidationErrors = await validateJointAccountOwners();

      if (!doNotHaveValidationErrors) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
      }
      return doNotHaveValidationErrors;
    });
  }, [props.financialApplicationId, validateJointAccountOwners]);

  return (
    <section className="joint-account-owner-info step-section">
      <div className="joint-account-owner-info__header step-header">
        Joint Owner Information
      </div>
      <div className="joint-account-owner-info__subtitle step-subtitle">
        Please provide joint owner information for verification purposes.
      </div>
      <div className="joint-account-owner-info-form__content step-content">
        <JointAccountOwners
          financialApplicationId={props.financialApplicationId}
          onBlur={props.onBlur}
          initiallyCollapseJointAccountOwnerForms={props.initiallyCollapseJointAccountOwnerForms}
          readOnly={props.readOnly}
          renderCollapsedAsTable={props.renderCollapsedAsTable}
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
          shouldHideSecurityQuestions={true}
          shouldAskIfCanProvideGovernmentIdInformation={true}
        />
      </div>
    </section>
  );
};
